export function format_age_range(min_age, max_age) {
    if (min_age && max_age) {
        return `Ages ${min_age}–${max_age}`;
    }

    if (!min_age && max_age) {
        return `up to ${max_age}`;
    }

    if (min_age && !max_age) {
        return `Ages ${min_age}+`;
    }

    return '';
}

// Compact form for structured data (e.g. schema.org typicalAgeRange).
// Defaults missing min to 5 since that's the floor for Critikid content.
export function format_age_range_compact(min_age, max_age) {
    if (!min_age && !max_age) return undefined;
    const min = min_age || 5;
    if (max_age) return `${min}-${max_age}`;
    return `${min}+`;
}